var _ellipse, _ellipse2, _ellipse3, _ellipse4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuerylizerLogomark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13,
    cy: 18.959,
    rx: 13,
    ry: 7.042,
    fill: "url(#a)",
    fillOpacity: 0.25
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13,
    cy: 15.167,
    rx: 13,
    ry: 7.042,
    fill: "url(#b)",
    fillOpacity: 0.5
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13,
    cy: 10.834,
    rx: 13,
    ry: 7.042,
    fill: "url(#c)",
    fillOpacity: 0.75
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13,
    cy: 7.042,
    rx: 13,
    ry: 7.042,
    fill: "url(#d)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 65.845,
    y1: 18.959,
    x2: 0,
    y2: 18.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE9FFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7367F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 65.845,
    y1: 15.167,
    x2: 0,
    y2: 15.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE9FFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7367F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 71.76,
    y1: 10.834,
    x2: 0,
    y2: 10.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE9FFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7367F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 13,
    y1: 25.858,
    x2: 13,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE9FFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7367F1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuerylizerLogomark);
export default __webpack_public_path__ + "static/media/querylizer-logomark.f4b8d9d8.svg";
export { ForwardRef as ReactComponent };